module.exports = __webpack_public_path__ + "static/media/lithuania.ed8100f9.svg";